import {
  ArrowDownCircleIcon,
  BuildingOfficeIcon,
} from "@heroicons/react/24/solid";
import React, { useRef, useState } from "react";
import MaterialTableTS from "../../../../components/tables/MaterialTableTS";
import { CSVLink } from "react-csv";
import { toast } from "../../../../components/toastNotification";
import useGetAllDarkOffices from "./hooks/useGetAllDarkOffices";
import DownloadButton from "../../../../components/DownloadButton";
import { CarrierAgreementMgmtTabs } from "../../carrierAgreementTabs";
import { useRecoilState, useRecoilValue } from "recoil";
import { mainSelectedTab } from "../../atoms";
import { useHistory } from "react-router-dom";
import { permissionsSelector } from "../../../Login/selectors/permissionSelector";
import { OfficeTabs } from "../../../OfficeTab/OfficeTabs";
import { accountAtom } from "../../../Login/atoms/AccountAtom";

interface IDarkOffices {
  officeType: string;
  officeName: string;
  storeNumber: string;
  officeStatus: string;
  officeCode: string;
  officeDarkReason: string;
  darkReasonEffectiveDate: string;
  officeSalesVP: string;
  salesVp: string;
  address: string;
  city: string;
  state: string;
  zipCode: number;
}

interface DarkOfficesProps {}
export const DarkOffices: React.FC<DarkOfficesProps> = () => {
  const [exportData, setExportData] = useState([]);
  const { data: darkOffices, isLoading: darkOfficesLoading } =
    useGetAllDarkOffices();
  const [, setSelectedIndex] = useRecoilState(mainSelectedTab);
  const history = useHistory();
  const userPermissions = useRecoilValue(permissionsSelector);
  const user = useRecoilValue(accountAtom);
  const tableRef = useRef<any>([]);

  function formatDate(date) {
    var d = new Date(date),
      month = "" + (d.getMonth() + 1),
      day = "" + d.getDate(),
      year = d.getFullYear();

    if (month.length < 2) month = "0" + month;
    if (day.length < 2) day = "0" + day;
    return [month, day, year].join("/");
  }

  //For downloading table data
  const mapDataToExport = (data) => {
    setExportData(
      data?.map((ofc: IDarkOffices) => {
        return {
          Type: ofc.officeType,
          "Office Name": ofc.officeName,
          "Corporate Office #": ofc.storeNumber,
          "Office Status": ofc.officeStatus,
          "Office Code": ofc.officeCode,
          "Office Dark Reason": ofc.officeDarkReason,
          "Dark Reason Effective Date": ofc.darkReasonEffectiveDate
            ? formatDate(ofc.darkReasonEffectiveDate)
            : "",
          "Office Sales VP": ofc.salesVp,
          Street: ofc.address,
          City: ofc.city,
          State: ofc.state,
          "Zip Code": ofc.zipCode,
        };
      })
    );
  };

  let dateTimeToday = new Date(new Date().toLocaleString()).toLocaleString();
  const csvReport = {
    filename: "DarkOfficesReports_" + dateTimeToday + ".csv",
    data: exportData,
  };
  const officeColumns = [
    { title: "Type", field: "officeType" },
    {
      title: "Office Name",
      field: "officeName",
      render: (rowData) => {
        return (
          <div
            className="cursor-pointer"
            onClick={() => {
              const url = "/officesettings/officesetting";
              history.push({
                pathname: url,
                state: {
                  pathname: url,
                  officeCode: rowData?.officeCode,
                  action: "DarkOfficeReports",
                },
              });
              window.location.reload();
              let userTabs = [
                {
                  to: "",
                },
              ];
              [...OfficeTabs].forEach((tabs) => {
                let temp = [...userPermissions].filter(
                  (user) => user === tabs.permission
                );
                if (temp.length > 0)
                  userTabs.push({
                    to: tabs.to,
                  });
              });
              userTabs.shift();
              const index = userTabs.findIndex((c) => c.to === url);
              setSelectedIndex(index);
            }}
          >
            <span className="text-quinary  font-bold underline text-sm ">
              {rowData.officeName}
            </span>
          </div>
        );
      },
    },
    { title: "Corporate Office #", field: "storeNumber" },
    { title: "Office Status", field: "officeStatus" },
    { title: "Office Code", field: "officeCode" },
    { title: "Dark Office Reason", field: "officeDarkReason" },
    {
      title: "Dark Reason Effective Date",
      field: "darkReasonEffectiveDate",
      render: (rowData) => {
        return (
          <div>
            {rowData.darkReasonEffectiveDate
              ? formatDate(rowData.darkReasonEffectiveDate)
              : ""}
          </div>
        );
      },
    },
    { title: "Sales VP", field: "salesVp" },
    { title: "Street", field: "address" },
    { title: "City", field: "city" },
    { title: "State", field: "state" },
    { title: "Zip Code", field: "zipCode" },
  ];

  return (
    <div className="text-xs items-center">
      <div className="">
        <div className="mx-4 mt-4 overflow-x-auto">
          <div className="flex mb-2 gap-2 items-center">
            <div>
              <BuildingOfficeIcon className="text-white bg-blue-500 rounded-md h-7 w-7 p-1" />
            </div>
            <div className="flex flex-col leading-tight">
              <div className="text-gray-500 text-md font-medium">
                Report: Accounts
              </div>
              <div className="flex items-center font-bold text-lg text-primary">
                Dark Offices
              </div>
            </div>
          </div>
          <div className="mt-2 " />
          <div className="flex justify-between mb-2 mr-2">
            <div className="flex items-center gap-1">
              <span className="text-gray-500 text-sm">Total Records: </span>
              <span className="text-primary text-base font-semibold">
                {
                  darkOffices?.filter((x) =>
                    user?.isFranchise && user?.isNonFranchise
                      ? true
                      : user?.isFranchise
                      ? x.officeType?.toLowerCase() === "franchise"
                      : x.officeType?.toLowerCase() !== "franchise"
                  ).length
                }
              </span>
            </div>
            <CSVLink className="" {...csvReport}>
              <DownloadButton
                buttonValue="Download File"
                onClick={() =>
                  mapDataToExport(tableRef.current.dataManager.searchedData)
                }
                className={undefined}
                disabled={undefined}
              />
            </CSVLink>
          </div>
        </div>
        <div className="box-shadow mx-4 mb-4 mt-2 overflow-x-auto grid grid-row">
          <MaterialTableTS
            data={darkOffices?.filter((x) =>
              user?.isFranchise && user?.isNonFranchise
                ? true
                : user?.isFranchise
                ? x.officeType?.toLowerCase() === "franchise"
                : x.officeType?.toLowerCase() !== "franchise"
            )}
            isLoading={darkOfficesLoading}
            columns={officeColumns}
            showTitle={false}
            showToolbar={true}
            toolbarSearch={true}
            searchFieldAlignment="left"
            tableRef={tableRef}
          />
        </div>
      </div>
    </div>
  );
};
